/* Lurelle cart drawer behaviour: opt-in shipping protection + kit upgrade. Re-renders Dawn's drawer from the
   Section Rendering API (same mechanism Dawn's product form uses), so quantities, totals and the cart bubble stay in sync. */
(function () {
  'use strict';
  var busy = false;

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    var list = d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender() : [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
    return list.map(function (s) { return s.id; });
  }
  function config() {
    return typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
  }
  function render(state) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function' && state && state.sections) d.renderContents(state);
    else window.location.reload();
  }
  function post(url, body) {
    if (busy) return Promise.resolve(null);
    busy = true;
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    var c = config();
    c.body = JSON.stringify(body);
    return fetch(url, c).then(function (r) { return r.json(); }).then(function (state) {
      busy = false;
      if (state && state.status && state.status >= 400) { console.warn('cart', state); return null; }
      render(state);
      return state;
    }).catch(function (e) { busy = false; console.warn('cart', e); });
  }
  var R = window.routes || {};
  var ADD = (R.cart_add_url || '/cart/add') + '.js';
  var UPDATE = (R.cart_update_url || '/cart/update') + '.js';

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-lx-protect]');
    if (!box) return;
    var wrap = box.closest('.lx-protect');
    if (wrap) wrap.classList.add('is-busy');
    var id = box.dataset.variant;
    if (box.checked) {
      post(ADD, { items: [{ id: Number(id), quantity: 1 }] });
    } else {
      var updates = {}; updates[id] = 0;
      post(UPDATE, { updates: updates });
    }
  });

  // One-time offer: when the drawer opens holding exactly one single box, show the "second box" modal once per session per cart state.
  function offerKey() { var o = document.querySelector('[data-lx-offer]'); return o ? 'lx_offer_' + o.dataset.key : null; }
  function showOffer() {
    var o = document.querySelector('[data-lx-offer]');
    if (!o) return;
    var k = offerKey(); var seen = false;
    try { seen = !!sessionStorage.getItem(k); } catch (e) {}
    if (seen) return;
    o.hidden = false; document.body.classList.add('lx-offer-open');
    try { sessionStorage.setItem(k, '1'); } catch (e) {}
  }
  function closeOffer() {
    var o = document.querySelector('[data-lx-offer]');
    if (o) o.hidden = true;
    document.body.classList.remove('lx-offer-open');
  }
  // Keep the Shipping Protection line at the bottom of the list (Shopify lists newest lines first).
  function protectionLast() {
    document.querySelectorAll('.lx-protection-line').forEach(function (tr) {
      var p = tr.parentElement; if (p && p.lastElementChild !== tr) p.appendChild(tr);
    });
  }
  protectionLast();
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () { protectionLast(); }).observe(drawerEl, { childList: true, subtree: true });
  }
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawerEl.classList.contains('active')) setTimeout(showOffer, 400);
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-lx-offer-close]')) { e.preventDefault(); closeOffer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOffer(); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lx-swap]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    closeOffer();
    var updates = {};
    updates[btn.dataset.from] = 0;
    updates[btn.dataset.to] = 1;
    post(UPDATE, { updates: updates });
  });
})();
